import React, {Component} from "react";
import PropTypes from "prop-types";

class Channel extends Component {
    componentDidMount() {
        const { name } = this.props;
        const { socketProvider } = this.context;

        if (!socketProvider) {
            console.warn('Socket IO connection has not been established.');
            return;
        }

        socketProvider.join([name]);
    }

    componentWillUnmount() {
        const { name } = this.props;
        const { socketProvider } = this.context;

        if (!socketProvider) {
            console.warn('Socket IO connection has not been established.');
            return;
        }

        socketProvider.leave([name]);
    }

    render() {
        return null;
    }
}

Channel.contextTypes = {
    socketProvider: PropTypes.object.isRequired,
};

Channel.propTypes = {
    name: PropTypes.string.isRequired,
};

export default Channel;
